<!-- Footer & Legal -->
<div class="footer" [class.flipped]="flip" [class.footer-dark]="darkMode">
  <!-- copyright -->
  <div class="copyright-info">
    ©<app-year></app-year> Bold Penguin • All rights reserved •
    <a target="_blank" href="https://www.boldpenguin.com/terms"
      >Terms & Conditions</a
    >
    •
    <a target="_blank" href="https://www.boldpenguin.com/privacy-policy"
      >Privacy Policy</a
    >
  </div>
  <!-- Powered By Pengs -->
  <bp-sdk-footer [darkMode]="darkMode"></bp-sdk-footer>
</div>
